import React from 'react';
import { Button, Portal, Snackbar } from '@mui/material';

/**
 * Short confirmations ("Cleared 12 cells", with Undo) and hints from the
 * spreadsheet commands. Clicking elsewhere does not dismiss it, so Undo stays
 * reachable while the user keeps working.
 */
export default function SpreadsheetFeedback({ feedback, onClose }) {
    return (
        <Portal>
            <Snackbar
                key={feedback?.key}
                open={Boolean(feedback)}
                autoHideDuration={feedback?.onUndo ? 6000 : 3500}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                onClose={(_event, reason) => {
                    if (reason !== 'clickaway') onClose();
                }}
                message={feedback?.message}
                action={feedback?.onUndo ? (
                    <Button color="inherit" size="small" onClick={feedback.onUndo}>
                        Undo
                    </Button>
                ) : null}
            />
        </Portal>
    );
}
